
declare var moment: any;

export class Card {

    Text = null;
    IsGregorian = null;
    TimeZoneID = null;
    IsFrequently = null;
    FrequencyTypeID = null;
    Year = null;
    Month = null;
    Day = null;
    Hour = null;
    Minute = null;
    Sat = null;
    Sun = null;
    Mon = null;
    Tue = null;
    Wed = null;
    Thu = null;
    Fri = null;
    GapAmount = null;

    TimeMode = null;
    StartYear = null;
    StartMonth = null;
    StartDay = null;
    EndYear = null;
    EndMonth = null;
    EndDay = null;
    HasTime = null;
    constructor() {
        const today = moment();

        this.Text = '';
        this.IsGregorian = false;
        this.TimeZoneID = 59;
        this.IsFrequently = false;
        this.FrequencyTypeID = 5;
        this.Year = today.jYear();
        this.Month = today.jMonth() + 1;
        this.Day = today.jDate();
        this.Hour = new Date().getHours();
        this.Minute = new Date().getMinutes();
        this.Minute = this.Minute - this.Minute % 5;
        this.TimeMode = this.Hour >= 12 ? 'PM' : 'AM';
        this.Hour = this.Hour % 12;
        this.Hour = this.Hour ? this.Hour : 12;



        this.Sat = false;
        this.Sun = false;
        this.Mon = false;
        this.Tue = false;
        this.Wed = false;
        this.Thu = false;
        this.Fri = false;
        this.GapAmount = 0;

        this.StartYear = null;
        this.StartMonth = null;
        this.StartDay = null;
        this.EndYear = null;
        this.EndMonth = null;
        this.EndDay = null;
        this.HasTime = 0;
    }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/card/card.ts